<template>
    <div class="roadmap-section">
        <div class="container">
            <div class="content-wrapper">
                <!-- Left Side - Roadmap Image -->
                <div class="image-container">
                    <div class="image-wrapper">
                        <img src="/wp-content/uploads/2024/02/roadmap-baru.png"
                            alt="The Long Journey of Socrates Legacy" class="roadmap-image">
                    </div>
                </div>

                <!-- Right Side - Tabs and Content -->
                <div class="tabs-container">
                    <!-- Year Tabs -->
                    <div class="year-tabs">
                        <button v-for="year in years" :key="year" :class="['year-tab', { active: activeYear === year }]"
                            @click="activeYear = year">
                            {{ year }}
                        </button>
                    </div>

                    <!-- Tab Content -->
                    <div class="tab-content">
                        <!-- 2021 Content -->
                        <div v-if="activeYear === '2021'" class="year-content">
                            <div class="milestone">
                                <h3>April</h3>
                                <ul>
                                    <li>Socrates Legacy was born with an SVG license and has partnered with a Tier 3
                                        Liquidity Provider.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>August</h3>
                                <ul>
                                    <li>Socrates successfully secured a total of $100,000 in investments from traders.
                                    </li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>November</h3>
                                <ul>
                                    <li>Socrates Legacy has collaborated with an additional Tier 3 Liquidity Provider,
                                        ensuring that traders consistently receive assets, backed by two distinct Tier 3
                                        LPs.</li>
                                </ul>
                            </div>
                        </div>

                        <!-- 2022 Content -->
                        <div v-if="activeYear === '2022'" class="year-content">
                            <div class="milestone">
                                <h3>April</h3>
                                <ul>
                                    <li>Socrates has successfully obtained a total of $250,000 in investments from
                                        traders.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>May</h3>
                                <ul>
                                    <li>Socrates has acquired its first Tier 2 Liquidity Partner named Broctagon.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>August</h3>
                                <ul>
                                    <li>Socrates has acquired its first Tier 1 Liquidity Partner named GBE Prime.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>November</h3>
                                <ul>
                                    <li>Socrates has successfully garnered a total of $500,000 in investments from
                                        traders.</li>
                                </ul>
                            </div>
                        </div>

                        <!-- 2023 Content -->
                        <div v-if="activeYear === '2023'" class="year-content">
                            <div class="milestone">
                                <h3>March</h3>
                                <ul>
                                    <li>Socrates has acquired its second Tier 1 Liquidy Partner named IS Prime.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>August</h3>
                                <ul>
                                    <li>Socrates Legacy has transitioned from an SVG license to an upgraded Forex
                                        License, registered by <strong>Comoros Union</strong> named
                                        <strong>International
                                            Brokerage and Clearing
                                            Houses license</strong>.
                                    </li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>September</h3>
                                <ul>
                                    <li>Socrates has successfully attracted a total of $1,000,000 in investments from
                                        traders.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>December</h3>
                                <ul>
                                    <li>MetaQuotes has announced that Socrates’ <strong>NEW</strong> license has been
                                        approved and is now
                                        ready for publication.</li>
                                </ul>
                            </div>
                        </div>

                        <!-- 2024 Content -->
                        <div v-if="activeYear === '2024'" class="year-content">
                            <div class="milestone">
                                <h3>February</h3>
                                <ul>
                                    <li>The publication has been carried out and complemented by improvements to the
                                        website for a better user experience.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>April or May (planning)</h3>
                                <ul>
                                    <li>Our reliable partner in Copytrading will be revealed around this month.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>May or June (planning)</h3>
                                <ul>
                                    <li>Our PAMM Account project will be finished around this month.</li>
                                </ul>
                            </div>
                            <div class="milestone">
                                <h3>August (planning)</h3>
                                <ul>
                                    <li>Our Indices product will be launch around this month, adding most famous indices
                                        such US30, US100, GER30, etc.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RoadmapSection',
    data() {
        return {
            activeYear: '2021',
            years: ['2021', '2022', '2023', '2024']
        }
    }
}
</script>

<style scoped>
.roadmap-section {
    background: #f5f5f5;
    padding: 100px 0;
    position: relative;
    overflow: hidden;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.content-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 60px;
    /* background: #fff; */
    /* border-radius: 20px; */
    /* padding: 60px; */
    /* box-shadow: 0 10px 50px rgba(0, 0, 0, 0.05); */
}

/* Left Side - Roadmap Image */
.image-container {
    flex: 0 0 45%;
}

.image-wrapper {
    position: relative;
}

.roadmap-image {
    width: 100%;
    height: auto;
    display: block;
    margin-bottom: 15px;
}

.image-caption {
    color: #666;
    font-size: 0.9rem;
    text-align: left;
    margin: 0;
    padding-left: 5px;
}

.image-caption::before {
    content: '• • • ';
    color: #333;
    margin-right: 5px;
}

/* Right Side - Tabs */
.tabs-container {
    flex: 1;
}

.year-tabs {
    display: flex;
    gap: 15px;
    margin-bottom: 40px;
    border-bottom: 2px solid #e0e0e0;
    padding-bottom: 0;
    width: fit-content;
}

.year-tab {
    font-family: "Roboto Mono", Sans-serif;
    background: none;
    border: none;
    font-size: 1.5rem;
    font-weight: 700;
    color: #333;
    cursor: pointer;
    padding: 12px 20px;
    transition: all 0.3s ease;
    position: relative;
    border-bottom: 3px solid transparent;
}

.year-tab:hover {
    color: #D4AF37;
}

.year-tab.active {
    color: #D4AF37;
    border-bottom-color: #D4AF37;
}

/* Tab Content */
.tab-content {
    min-height: 400px;
}

.year-content {
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.milestone {
    margin-bottom: 30px;
}

.milestone:last-child {
    margin-bottom: 0;
}

.milestone h3 {
    font-family: "Fira Sans", Sans-serif;
    color: #1a1a1a;
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 12px;
}

.milestone ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.milestone li {
    color: #666;
    font-size: 1rem;
    line-height: 1.8;
    padding-left: 20px;
    position: relative;
    margin-bottom: 8px;
}

.milestone li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #333;
    font-weight: 700;
}

/* Responsive Design */
@media (max-width: 992px) {
    .content-wrapper {
        gap: 40px;
        padding: 50px 40px;
    }

    .year-tab {
        font-size: 1.3rem;
        padding: 10px 15px;
    }

    .milestone h3 {
        font-size: 1.2rem;
    }
}

@media (max-width: 768px) {
    .roadmap-section {
        padding: 60px 0;
    }

    .content-wrapper {
        flex-direction: column;
        gap: 40px;
        padding: 40px 30px;
    }

    .image-container {
        flex: 0 0 100%;
        max-width: 500px;
        margin: 0 auto;
    }

    .year-tabs {
        gap: 10px;
        margin-bottom: 30px;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 5px;
    }

    .year-tab {
        font-size: 1.2rem;
        padding: 10px 18px;
        white-space: nowrap;
    }

    .tab-content {
        min-height: 300px;
    }

    .milestone h3 {
        font-size: 1.1rem;
    }

    .milestone li {
        font-size: 0.95rem;
    }
}

@media (max-width: 480px) {
    .roadmap-section {
        padding: 40px 0;
    }

    .content-wrapper {
        padding: 30px 20px;
        gap: 30px;
    }

    .year-tabs {
        gap: 8px;
        margin-bottom: 25px;
    }

    .year-tab {
        font-size: 1.1rem;
        padding: 8px 15px;
    }

    .tab-content {
        min-height: 250px;
    }

    .milestone {
        margin-bottom: 25px;
    }

    .milestone h3 {
        font-size: 1rem;
        margin-bottom: 10px;
    }

    .milestone li {
        font-size: 0.9rem;
        line-height: 1.7;
    }

    .image-caption {
        font-size: 0.85rem;
    }
}
</style>
